/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetActiveCompetitionsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetActiveCompetitionsArgs, useGetActiveCompetitionsSpec, useGetActiveCompetitionsRealtime, useGetActiveCompetitionsPagination } from '../specs/competitions.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetActiveCompetitionsRow } from '../openapi-types.gen.js';
export type { useGetActiveCompetitionsArgs } from '../specs/competitions.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetActiveCompetitionsPaginationContract = useGetActiveCompetitionsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetActiveCompetitionsInfinite` — both
 * read/write the same `PagedData<GetActiveCompetitionsRow>` blob.
 */
const _useGetActiveCompetitions = createListHook({
  spec: useGetActiveCompetitionsSpec,
  realtime: useGetActiveCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetActiveCompetitionsPaginationContract,
});
export const useGetActiveCompetitions = _useGetActiveCompetitions as (args: useGetActiveCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetActiveCompetitions>;


/**
 * Auto-infinite: same cache as `useGetActiveCompetitions`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetActiveCompetitions` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetActiveCompetitionsInfinite = createListHook({
  spec: useGetActiveCompetitionsSpec,
  realtime: useGetActiveCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetActiveCompetitionsPaginationContract,
  autoLoadMore: true,
});
export const useGetActiveCompetitionsInfinite = _useGetActiveCompetitionsInfinite as (args: useGetActiveCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetActiveCompetitionsInfinite>;


/**
 * Per-field subscription hook for the `useGetActiveCompetitions` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetActiveCompetitionsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetActiveCompetitionsField = createFieldHook<GetActiveCompetitionsRow>('useGetActiveCompetitionsField');

/**
 * Hover/intent prefetch companion for `useGetActiveCompetitions` (also covers
 * `useGetActiveCompetitionsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetActiveCompetitions();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetActiveCompetitions = createPrefetchHook(useGetActiveCompetitionsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetActiveCompetitionsArgs>;
